module.exports = __webpack_public_path__ + "img/bg_video1.b5b70569.jpg";